import { render, staticRenderFns } from "./NewClientFile.vue?vue&type=template&id=124c48ce&"
import script from "./NewClientFile.vue?vue&type=script&lang=js&"
export * from "./NewClientFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports